import { Outlet } from "react-router-dom"
import TopLayerContainer from "@/components/TopLayerContainer"
import { useAuth } from "@/auth/useAuth"
import { TokenKey, NHTokenKey } from "@/constants/config"

function TabPage() {
  const { user } = useAuth()
  return (
    <>
      {(user?.[TokenKey] || user?.[NHTokenKey]) && <TopLayerContainer />}
      <Outlet />
    </>
  )
}

export default TabPage
